import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgBin = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.9132 7H7.0868L7.92013 17H14.0799L14.9132 7ZM16.9201 7L15.9201 19H6.07987L5.07987 7H4V5H18V7H16.9201ZM9 4V2H13V4H9Z"
      fill="currentColor"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgBin);

export default ForwardRef;
